module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-header"
  }, [_vm._v("\n    " + _vm._s(_vm.adminName) + "\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58a60e4c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/header.vue
// module id = 3228
// module chunks = 1